import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore,
} from "redux";
import thunk from "redux-thunk";
import { GET_LOCAL } from "./Models/LocalData";
import { LoginReducer } from "./Reducers/userLoginReducer";
import {
  LIST_UNIVERSITY_WEB_DETAILS_REDUCER,
  CREATE_UNIVERSITY_WEB_DETAILS_REDUCER,
  UPDATE_UNIVERSITY_WEB_DETAILS_REDUCER,
  DELETE_UNIVERSITY_WEB_DETAILS_REDUCER,
  UNIVERSITY_WEB_DETAILS_SINGLE_DATA_REDUCER,
} from "./Reducers/universityWebDetailsReducer";

import {
  UNIVERSITY_LIST_REDUCER,
  UNIVERSITY_SINGLE_DATA_REDUCER,
  UNIVERSITY_LIST_CREATE_REDUCER,
  UNIVERSITY_LIST_UPDATE_REDUCER,
  UNIVERSITY_DELETE_REDUCER,
} from "./Reducers/universityReducer";
import { COUNTRY_LIST_REDUCER } from "./Reducers/countryReducer";

import {
  CAMPUS_LIST_REDUCER,
  CAMPUS_SINGLE_DATA_REDUCER,
  CAMPUS_CREATE_REDUCER,
  CAMPUS_UPDATE_REDUCER,
  CAMPUS_DELETE_REDUCER,
  CAMPUS_LIST_BY_COURSE_REDUCER,
} from "./Reducers/campusReducer";

import {
  COURSE_LISTS_REDUCER,
  COURSE_SINGLE_DATA_REDUCER,
  COURSES_TOTAL_DATA_REDUCER,
  COURSES_CREATE_REDUCER,
  COURSE_LIST_UPDATE_REDUCER,
  COURSE_DELETE_REDUCER,
  CAMPUS_ADD_BY_COURSES_REDUCER,
  CAMPUS_DELETE_BY_COURSE,
} from "./Reducers/coursesReducer";

import { INTAKE_LIST_REDUCER } from "./Reducers/intakeReducer";
import { COURSE_OFFERED_LIST_REDUCER } from "./Reducers/courseOfferedReducer";
import {
  UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_REDUCER,
  UNIVERSITY_IMAGE_UPLOAD_REDUCER,
} from "./Reducers/universityImageUploadReducer";
import {
  listContactReducer,
  sendContactReducer,
} from "./Reducers/contactReducer";
import { listPartnerReducer } from "./Reducers/partnerReducer";
import { listUserReducer } from "./Reducers/userReducer";

const InitialState = {
  LoginReducer: {
    accessToken: GET_LOCAL("login_data")?.accesstoken,
    userDet: GET_LOCAL("login_data")?.Result,
  },
};

const rootReducers = combineReducers({
  LoginReducer,
  LIST_UNIVERSITY_WEB_DETAILS_REDUCER,
  CREATE_UNIVERSITY_WEB_DETAILS_REDUCER,
  UPDATE_UNIVERSITY_WEB_DETAILS_REDUCER,
  DELETE_UNIVERSITY_WEB_DETAILS_REDUCER,
  UNIVERSITY_WEB_DETAILS_SINGLE_DATA_REDUCER,
  UNIVERSITY_LIST_REDUCER,
  UNIVERSITY_SINGLE_DATA_REDUCER,
  UNIVERSITY_LIST_CREATE_REDUCER,
  UNIVERSITY_LIST_UPDATE_REDUCER,
  UNIVERSITY_DELETE_REDUCER,
  CAMPUS_LIST_REDUCER,
  CAMPUS_SINGLE_DATA_REDUCER,
  CAMPUS_LIST_BY_COURSE_REDUCER,
  CAMPUS_CREATE_REDUCER,
  CAMPUS_UPDATE_REDUCER,
  CAMPUS_DELETE_REDUCER,
  COUNTRY_LIST_REDUCER,
  COURSE_LISTS_REDUCER,
  COURSE_SINGLE_DATA_REDUCER,
  COURSES_TOTAL_DATA_REDUCER,
  COURSES_CREATE_REDUCER,
  COURSE_LIST_UPDATE_REDUCER,
  COURSE_DELETE_REDUCER,
  CAMPUS_ADD_BY_COURSES_REDUCER,
  CAMPUS_DELETE_BY_COURSE,
  INTAKE_LIST_REDUCER,
  COURSE_OFFERED_LIST_REDUCER,
  UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_REDUCER,
  UNIVERSITY_IMAGE_UPLOAD_REDUCER,
  sendContactReducer,
  listContactReducer,
  listPartnerReducer,
  listUserReducer,
});

export const store = legacy_createStore(
  rootReducers,
  InitialState,
  applyMiddleware(thunk)
);
